import * as React from 'react';
import UserOrderModel from '../../domain/UserOrder';
import '../UserTableRow.css';
import { Link } from 'react-router-dom';
import OrderDocumentRequested from '../../application/order/events/OrderDocumentRequested';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';
import { connect } from 'react-redux';
import orderStatusTranslator from './OrderStatusTranslator';
import formatNumber, { formatPrice } from '../formatNumber';
import Role from '../../domain/Role';
import ApplicationState from '../../application/core/State';

interface StateProps {
    userRole: Role;
}

interface Props {
    userOrder: UserOrderModel;
    customerId: string;
    link: (orderId: number) => string;
}

export type OrderDocumentType = 'OrderConfirmation' | 'PackList' | 'Proforma' | 'Invoice';

class UserOrder extends React.PureComponent<Props & DispatchProps & StateProps> {
    public render(): JSX.Element {
        return (
            <div className="user-table-details-row">
                <div>
                    <Link to={this.props.link(this.props.userOrder.id)}>{this.props.userOrder.id}</Link>
                </div>
                <div>
                    <span>{this.props.userOrder.placedDate}</span>
                </div>
                <div>
                    <span>{this.props.userOrder.deliveryDrop.year + '/' + this.props.userOrder.deliveryDrop.month}</span>
                </div>
                <div>
                    <span>{this.props.userOrder.type}</span>
                </div>
                <div>
                    <span>{formatPrice(this.props.userOrder.total)}</span>
                </div>
                <div>
                    <span>{formatNumber(this.props.userOrder.quantity, 0)}</span>
                </div>
                <div>
                    <span>
                        {this.props.userRole === Role.User
                            ? orderStatusTranslator(this.props.userOrder.status)
                            : this.props.userOrder.status}
                    </span>
                </div>
                <div>{this.linkToDocument(this.props.userOrder.orderConfirmation, 'Order confirmation', 'OrderConfirmation')}</div>
                <div>{this.linkToDocument(this.props.userOrder.packList, 'Pack list', 'PackList')}</div>
                <div>{this.linkToDocument(this.props.userOrder.proforma, 'Pro-forma invoice', 'Proforma')}</div>
                <div>{this.linkToDocument(this.props.userOrder.invoice, 'Invoice', 'Invoice')}</div>
            </div>
        );
    }

    private linkToDocument = (documentId: string, label: string, documentType: OrderDocumentType): JSX.Element | null => {
        if (documentId) {
            return (
                <span className="link-button" onClick={this.downloadPDF.bind(this, documentId, label, documentType)}>
                    {label}
                </span>
            );
        } else if (documentType === 'OrderConfirmation' || documentType === 'PackList' || documentType === 'Invoice') {
            return <span className="italic">in progress</span>;
        } else {
            return null;
        }
    };

    private downloadPDF = (documentId: string, fileName: string, documentType: OrderDocumentType): void => {
        this.props.dispatch(new OrderDocumentRequested(documentType, documentId, this.props.customerId));
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    userRole: state.user.role
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserOrder);



// WEBPACK FOOTER //
// ./src/view/order/UserOrder.tsx